<template>
  <div class="nav-layout">
    <div class="nav-inner">
      <div class="nav-inner-left">
        <!-- logo -->
        <div class="logo-wrap">
          <img class="logo-img" :src="logoPath" alt="logo" />
        </div>
        <!-- 菜单 -->
        <div class="menus">
          <div
            :key="menu.path"
            class="menu pointer"
            v-for="menu in menus"
            @click="navigateTo(menu)"
            :class="{ act: actMenuName === menu.name, ...menu.class }"
          >
            {{ menu.name }}
          </div>
        </div>
      </div>
      <!-- 搜索输入框 -->
      <search-input />
      <!-- 用户登录 -->
      <user-login />
    </div>
  </div>
</template>
<script>
const logoPath = require("@/assets/img/logo.png");
import SearchInput from "./SearchInput.vue";
import UserLogin from "./UserLogin.vue";
export default {
  name: "nav-layout",
  components: { SearchInput, UserLogin },
  data: function () {
    return {
      logoPath,
      actMenuName: "首页",
      menus: [
        {
          name: "首页",
          path: "/home",
          class: {},
        },
        {
          name: "问答",
          path: "/question",
          class: {},
        },
        {
          name: "社群",
          path: "/community",
          class: {},
        },
        {
          name: "推广",
          path: "/activity",
          class: {},
        },
        {
          name: "AI助研",
          path: "/ai",
          class: {
            // "linear-color": true,
            "tour-step-3": true,
          },
        },
      ],
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { ancestor = "" } = route.meta;
        const targetMenu = this.menus.find((menu) => menu.name === ancestor);
        targetMenu && (this.actMenuName = targetMenu.name);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /* 跳转菜单 */
    navigateTo(menu) {
      if (menu.path === this.$route.path) return;
      this.$router.push({ path: menu.path });
      // this.actMenuName = menu.name;
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-layout {
  top: 0;
  z-index: 186;
  position: sticky;
  position: -webkit-sticky;
  box-shadow: 0 1px 3px oklch(from #c2c6cf l c h/.1);
  background-color: #fff;
  .nav-inner {
    margin: 0 auto;
    min-width: 1020px;
    width: 60%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    // padding: 0 10px;
    .nav-inner-left {
      display: flex;
      gap: 33px;
      flex: 1;
      .logo-wrap {
        .logo-img {
          width: 40px;
          height: 40px;
        }
      }
      .menus {
        display: flex;
        gap: 52px;
        align-items: center;
        .menu {
          transition: all 0.2s;
          &:hover {
            color: var(--color-primary);
          }
        }
        .linear-color {
          background: linear-gradient(
            0deg,
            #947dfe 30%,
            #0aa3ef 100%
          ); /* 渐变背景 */
          -webkit-background-clip: text; /* 裁剪背景到文本区域 */
          background-clip: text;
          color: transparent; /* 设置文本颜色为透明 */
        }
        .menu.act {
          color: var(--color-primary);
        }
      }
    }
  }
}
</style>
